<header class="ion-header ion-hide-lg-up">
  <header-main></header-main>
  <div class="ion-fab">
    <div class="ion-fab-button close button-tertiary button-round">
      <a href="/jobs">
        <img class="ion-icon" src="assets/icons/close.svg">
      </a>
    </div>
  </div>
</header>

<main class="ion-content" *ngIf="job" fullscreen class="j">
  <header class="ion-hide-lg-down">
    <header-desktop></header-desktop>
    <h1>
      <svg class="ion-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32.73 27.93"><defs><style>.jobs{stroke:none;}</style></defs><title>jobs</title><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path class="jobs" d="M28.07,5.76H23.61V4.7A4.71,4.71,0,0,0,18.91,0H13.82a4.71,4.71,0,0,0-4.7,4.7v6.86a1,1,0,0,0,2,0V7.76H21.61v3.8a1,1,0,1,0,2,0V7.76h4.46a2.67,2.67,0,0,1,2.66,2.67V23.27a2.66,2.66,0,0,1-2.66,2.66H4.67A2.67,2.67,0,0,1,2,23.27V10.43A2.68,2.68,0,0,1,4.67,7.76a1,1,0,0,0,0-2A4.68,4.68,0,0,0,0,10.43V23.27a4.67,4.67,0,0,0,4.67,4.66h23.4a4.66,4.66,0,0,0,4.66-4.66V10.43A4.67,4.67,0,0,0,28.07,5.76Zm-17,0V4.7A2.7,2.7,0,0,1,13.82,2h5.09a2.7,2.7,0,0,1,2.7,2.7V5.76Z"></path></g></g></svg>
      {{job.title}}
    </h1>
  </header>
  <div class="container-fluid">
    <div class="row">
      <div class="col col-xs-12 col-md-10 col-lg-8 col-xl-6 col-md-offset-1 col-lg-offset-2 col-xl-offset-3">
        <div class="ion-card detail ion-margin ion-padding">
          <div class="ion-card-content ion-padding">
            <div class="ion-card-title">{{job.title}}</div>
            <div class="subtitle">
              <span class="location ion-padding-end">
                <img *ngIf="job.country" class="ion-icon" src="assets/flags/{{job.country | lowercase}}.svg"/>
                <ng-container *ngIf="job.location == 'onsite'">
                  <ng-container *ngIf="job.suburb || job.city">{{job.suburb}} {{job.city}}</ng-container>
                  <ng-container *ngIf="!(job.suburb || job.city)">{{directory_data.name}}</ng-container>
                </ng-container>
                <ng-container *ngIf="job.location == 'remote'">Remote</ng-container>
              </span>
              <span><img class="ion-icon" src="assets/icons/star.svg"/></span>
              <span *ngIf="job.alias"><span class="ion-hide-sm-down">Posted By </span>{{job.alias}}</span>
              <span *ngIf="job.rating" class="ion-hide-sm-down"> - {{job.rating | number:'1.0-0'}} star job lister</span>
            </div>
            <youtube-player *ngIf="job.video && job.video.indexOf('@') === -1 && job.video.indexOf('channel') === -1 && job.video.indexOf('playlist') === -1 && job.video.indexOf('fb.watch') === -1 && job.video.indexOf('vimeo') === -1" [vid]="job.video"></youtube-player>
            <div class="container-fluid">
              <div class="row">
                <div class="col col-xs-12 col-sm-7 ion-no-padding details">
                  <div class="ion-card-subtitle">Details</div>
                  <p>{{job.overview}}</p>
                  <ul>
                      <li *ngIf="job.highlight1">{{job.highlight1}}</li>
                      <li *ngIf="job.highlight2">{{job.highlight2}}</li>
                      <li *ngIf="job.highlight3">{{job.highlight3}}</li>
                  </ul>
                  <div class="ion-card-subtitle">Location</div>
                  <p *ngIf="job.location == 'onsite'">On-Site<span *ngIf="job.suburb || job.city"> - {{job.suburb}} {{job.city}}</span></p>
                  <p *ngIf="job.location == 'remote'">Remote - Work from Anywhere</p>
                  <div class="ion-card-subtitle">Published</div>
                  <ng-container *ngIf="(job.grouping | type) === 'string'">
                    <p *ngIf="job.grouping">{{job.grouping}} - {{job.classification}}</p>
                  </ng-container>
                  <ng-container *ngIf="(job.grouping | type) === 'object'">
                    <p *ngFor="let group of job.grouping; let i = index">in {{group}} - {{job.classification[i]}}</p>
                  </ng-container>
                  <p *ngIf="job.company">by {{job.company}}</p>
                  <p *ngIf="job.reference">ref {{job.reference}}</p>
                  <div class="ion-card-subtitle">Ad Targeting</div>
                  <a *ngIf="job.all && job.country !== 'GB'" href="https://{{job.country | lowercase}}.gigexchange.com/location/{{directory_data.slug}}"><button class="button-primary button-round button-small button-solid ion-chip">All of {{job.country}}</button></a>
                  <a *ngIf="job.all && job.country == 'GB'" href="https://{{directory_data.slug}}.gigexchange.com/location/{{directory_data.slug}}"><button class="button-primary button-round button-small button-solid ion-chip">All of {{directory_data.slug | uppercase}}</button></a>
                  <ng-container *ngIf="!job.all && job.country !== 'GB'">
                    <a *ngIf="!job.cities && !job.regions" href="https://{{job.country | lowercase}}.gigexchange.com/location/{{directory_data.slug}}"><button class="button-primary button-round button-small button-solid ion-chip">All of {{job.country}}</button></a>
                    <a *ngFor="let city of job.cities" href="https://{{job.country | lowercase}}.gigexchange.com/location/{{directory_data.slug}}/{{city | slugify}}"><button class="button-primary button-round button-small button-solid ion-chip">{{city}}</button></a>
                    <a *ngFor="let region of job.regions" href="https://{{job.country | lowercase}}.gigexchange.com/location/{{directory_data.slug}}/{{region | slugify}}"><button class="button-primary button-round button-small button-solid ion-chip">{{region}}</button></a>
                  </ng-container>
                  <ng-container *ngIf="!job.all && job.country == 'GB'">
                    <a *ngIf="!job.cities && !job.regions" href="https://{{directory_data.slug}}.gigexchange.com/location/{{directory_data.slug}}"><button class="button-primary button-round button-small button-solid ion-chip">All of {{directory_data.slug | uppercase}}</button></a>
                    <a *ngFor="let city of job.cities" href="https://{{directory_data.slug}}.gigexchange.com/location/{{directory_data.slug}}/{{city | slugify}}"><button class="button-primary button-round button-small button-solid ion-chip">{{city}}</button></a>
                    <a *ngFor="let region of job.regions" href="https://{{directory_data.slug}}.gigexchange.com/location/{{directory_data.slug}}/{{region | slugify}}"><button class="button-primary button-round button-small button-solid ion-chip">{{region}}</button></a>
                  </ng-container>
                </div>
                <div class="col col-xs-12 col-sm-5 ion-no-padding application">
                  <div class="apply-box">
                    <div class="ion-card-subtitle">Remuneration</div>
                    <h4 *ngIf="job.type">
                      <ng-container *ngIf="job.type != 'P' && job.rate" color="primary">
                        {{job.rate.lower | currency : (job.currency | uppercase) : 'symbol' : '1.0-0'}}-{{job.rate.upper}}ph
                      </ng-container>
                      <ng-container *ngIf="job.type == 'P' && job.salary" color="primary">
                        {{job.salary.lower | currency : (job.currency | uppercase) : 'symbol' : '1.0-0'}}-{{job.salary.upper}}k
                      </ng-container>
                      <small *ngIf="job.type == 'P'">Permanent</small>
                      <small *ngIf="job.type == 'T'">Temporary</small>
                      <small *ngIf="job.type == 'C'">Contract</small>
                    </h4>
                    <ng-container *ngIf="!job.complete && job.visibility">
                      <ng-container *ngIf="auth.user | async as user; else guest;">
                        <apply-job *ngIf="user.jobhunter && user.classification && user.experience && user.available && (user.uid != job.customer)" [customerid]="job.customer" [jobid]="job.id" [title]="job.title" [uid]="user.uid" apply="true"></apply-job>
                        <ng-container *ngIf="!(user.jobhunter && user.classification && user.experience && user.available)">
                          <p><button class="button-solid button-tertiary button-round" (click)="isApply=!isApply">Apply now</button></p>
                          <a *ngIf="user.welcome && isApply" href="/account/profile/"><button class="button-solid button-white button-round">Update profile</button></a>
                          <a *ngIf="!user.welcome && isApply" href="/account/profile/jobs"><button class="button-solid button-white button-round">Update profile</button></a>
                        </ng-container>
                      </ng-container>
                      <ng-template #guest>
                        <p><button class="button-solid button-tertiary button-round" (click)="isApply=!isApply">Apply now</button></p>
                        <a *ngIf="isApply" href="/account/profile/jobs"><button class="button-solid button-white button-round">Update profile</button></a>
                      </ng-template>
                    </ng-container>
                    <ng-container *ngIf="job.complete || !job.visibility">
                      <p><button class="button-solid button-secondary button-round ion-margin-top ion-margin-end ion-margin-bottom">Complete</button></p>
                    </ng-container>
                    <ng-container *ngIf="job.logo">
                      <hr>
                      <img class="logo" [src]="bucketURL + job.logo + '?alt=media'" alt="{{job.company}}" onerror="this.style.display='none'" />
                    </ng-container>
                  </div>
                </div>
                <div class="col col-xs-12 ion-no-padding description">
                  <div class="ion-card-subtitle">Job Description</div>
                  <p class="description" [innerHTML]="job.description"></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <feature-skills *ngIf="job.country!=='GB'" [code]="job.country" [country]="directory_data.name" [slug]="directory_data.slug" [grouping]="job.grouping" [classification]="job.classification" service="Jobs"></feature-skills>
  <feature-skills *ngIf="job.country=='GB'" [code]="directory_data.slug" [country]="directory_data.name" [slug]="directory_data.slug" [grouping]="job.grouping" [classification]="job.classification" service="Jobs"></feature-skills>
  <footer class="ion-hide-lg-down">
    <footer-desktop></footer-desktop>
  </footer>
</main>

<footer class="ion-footer ion-hide-lg-up">
  <footer-main></footer-main>
</footer>